<template>
  <div
    v-if="isVisible"
    class="tw-z-[20] tw-rounded-md tw-border tw-border-system-warning-500 tw-bg-system-warning-50 tw-p-3"
    role="alert"
    data-test-id="mail-flow-migration-banner"
  >
    <div class="tw-flex tw-items-center tw-gap-2">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-rounded-md tw-bg-system-warning-100 tw-p-1"
        data-test-id="mail-flow-migration-banner-icon"
      >
        <cb-icon-attention-critical
          color="currentColor"
          class="tw-text-system-warning-500"
        />
      </div>
      <div
        class="tw-flex-grow tw-overflow-hidden tw-whitespace-normal tw-break-words"
      >
        <div
          class="tw-text-lg tw-font-semibold"
          data-test-id="mail-flow-migration-banner-title"
        >
          This page is temporarily unavailable
        </div>
      </div>
    </div>
    <div
      class="tw-ml-10 tw-text-sm"
      data-test-id="mail-flow-migration-banner-message"
    >
      We're busy making improvements to the mail flow configuration. These
      settings will be unavailable for the next
      <span class="tw-font-semibold">30 minutes</span>. Email filtering will
      continue to function as normal.
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useFlag } from "@/composables/useFlags/useFlag";

// Shown while the MAIL_FLOW_PAGE_DISABLED migration lock is engaged (H-3689):
// the same flag hides the Mail flow nav item and blocks its routes, so the
// lock and this banner can never disagree. Deliberately not dismissible — it
// covers a ~30 minute maintenance window. Copy is hardcoded: the banner is
// temporary and no Ditto keys exist for it.
const route = useRoute();

const { isFeatureAvailable: isMailFlowPageDisabled } = useFlag(
  "MAIL_FLOW_PAGE_DISABLED",
);

const isVisible = computed(
  () =>
    isMailFlowPageDisabled.value &&
    (route.name === "msp-email_security-overview" ||
      route.name === "customer-email_security-overview"),
);
</script>
